/**
 * IMPORTS
 */
import React from "react";

import { ActionMeta, GroupBase, Props as SelectProps, SingleValue } from "react-select";
import { AsyncPaginate, LoadOptions } from "react-select-async-paginate";

type Option = {
  label: string;
  value: string;
};

interface SelectBaseAsyncProps extends Partial<SelectProps<Option, false, GroupBase<Option>>> {
  label?: string;
  placeholder?: string;
  loadOptions: LoadOptions<Option, GroupBase<Option>, { page: number }>;
  onChange?: (newValue: SingleValue<Option>, actionMeta: ActionMeta<Option>) => void;
}

export const SelectBaseAsync: React.FC<SelectBaseAsyncProps> = ({
  label,
  loadOptions,
  placeholder = "Selecione uma opção",
  onChange,
  ...rest
}) => {
  return (
    <div>
      {label && (
        <label className="mb-2 block bg-neutral-50 text-sm font-medium text-zinc-800">
          {label}
        </label>
      )}
      <AsyncPaginate
        className="rounded border border-zinc-800 bg-neutral-50 font-normal text-gray-700"
        loadOptions={loadOptions}
        additional={{ page: 1 }}
        placeholder={placeholder}
        onChange={onChange}
        debounceTimeout={300}
        isClearable
        {...rest}
      />
    </div>
  );
};
